import { Component, HostBinding, Input } from '@angular/core';
import { ShipmentService } from '../../../ship/services/shipment.service';

@Component({
    selector: 'upsc-delivery-defense-score-summary',
    templateUrl: './delivery-defense-score-summary.component.html',
    styleUrls: ['./delivery-defense-score-summary.component.scss'],
})
export class DeliveryDefenseScoreSummaryComponent {
    @Input() public value = 0;
    @Input() public address: any;
    @Input() public addressType: string;

    @HostBinding('class') public hostClass = 'delivery-defense-score-summary';

    constructor(private readonly shipmentService: ShipmentService) {
    }

    public get confidenceLevel(): 'none' | 'low' | 'average' | 'high' {
        return this.shipmentService.getAddressConfidenceLevel(this.value || 0);
    }

    public get ddScore(): number {
        return this.value || 0;
    }

    public get addressString(): string {
        if (!this.address) {
            return '';
        }

        return [
            this.address.StreetAddress,
            this.address.ApartmentSuite,
            this.address.City,
            this.address.State,
            this.address.Zip,
        ].filter(Boolean).join(', ');
    }
}
